var React = require('react');

function Manifesting (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .forms {\n        fill:#e5fd57;\n        stroke:#000;\n        stroke-miterlimit:10;\n      }\n    ")),React.createElement("path",{"className":"forms","d":"M170.35,475.49l125.83-26.21V105L127.89.52.5,21.9V349.63Z","key":1})]);
}

Manifesting.defaultProps = {"id":"manifesting","data-name":"manifesting","viewBox":"0 0 296.68 476.03"};

module.exports = Manifesting;

Manifesting.default = Manifesting;
